/**
 * Calculates the intersection of two lines based on four provided points
 *
 * @param {Point} a - First point on first line
 * @param {Point} b - Second point on first line
 * @param {Point} c - First point on second line
 * @param {Point} d - Second point on second line
 * @param {Number} fudge - Amount to extend the intersection along the first line
 * @return {Object} The intersection point with location details
 */

export default function intersection(a, b, c, d, fudge = 1.01) {
  const denom = (d.y - c.y) * (b.x - a.x) - (d.x - c.x) * (b.y - a.y)

  if (denom == 0) return {}

  const ua = ((d.x - c.x) * (a.y - c.y) - (d.y - c.y) * (a.x - c.x)) / denom
  const ub = ((b.x - a.x) * (a.y - c.y) - (b.y - a.y) * (a.x - c.x)) / denom

  return {
    x: a.x + ua * fudge * (b.x - a.x),
    y: a.y + ua * fudge * (b.y - a.y),
    in: ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1,
    ua
  }
}



// WEBPACK FOOTER //
// ./src/helpers/walls/intersection.js